import React, { Fragment } from 'react';
import useTelemetry from '../hooks/useTelemetry';
import { useDashboardSettings } from '../hooks/useDashboardSettings';
import { useMenu } from '../hooks/useMenu';
import useTelemetryConfirm from '../hooks/useTelemetryConfirm';
import { useDashboardActions } from '../hooks/useDashboardActions';
import FloatingMenu from './floating-menu';
import ConfigDrawer from './config-drawer';
import SettingsPopover from './settings-popover';
import TelemetryConfirmDialog from './telemetry-confirm-dialog';
import { AddWidgetModal } from '../../../../../CommonComponents/telemetry';

export const TelemetryModals: React.FC = () => {
  const {
    dashboards,
    activeDashboard,
    activeLayout,
    setLayout,
    patchWidget,
    removeWidget,
    configPanel,
    setConfigPanel,
    addModalOpen,
    setAddModalOpen,
    insertGap,
    setInsertGap,
    renameWorkspace,
    duplicateWorkspace,
    deleteWorkspace,
  } = useTelemetry();

  const {
    precision,
    setPrecision,
    units,
    setUnit,
    timeframe,
    layoutMode,
    setLayoutMode,
    settingsOpen,
    setSettingsOpen,
  } = useDashboardSettings();


  const { menu, openMenu, closeMenu } = useMenu();

  const {
    confirmState,
    closeConfirmDialog,
    handleConfirm,
    confirmWidgetDeletion,
  } = useTelemetryConfirm();

  const { handleAddWidget } = useDashboardActions({
    activeLayout,
    setLayout,
    dashboards,
    openMenu,
    closeMenu,
    renameWorkspace,
    duplicateWorkspace,
    deleteWorkspace,
    setInsertGap,
    insertGap,
  });

  const handleRemoveWidget = (id: string) => {
    const widget = activeLayout.find((w) => w.id === id);
    confirmWidgetDeletion(widget?.name || 'Panel', () => removeWidget(id));
  };

  return (
    <Fragment>
      {/* Floating Menu */}
      <FloatingMenu menu={menu} onClose={closeMenu} />

      {/* Add Widget Modal */}
      <AddWidgetModal
        open={addModalOpen}
        onClose={() => {
          setAddModalOpen(false);
          setInsertGap(null);
        }}
        onAdd={handleAddWidget}
        initialSubsystem={activeDashboard?.name}
      />

      {/* Config Drawer */}
      <ConfigDrawer
        panel={configPanel}
        onClose={() => setConfigPanel(null)}
        patchWidget={patchWidget}
        removeWidget={handleRemoveWidget}
        openMenu={openMenu}
        closeMenu={closeMenu}
        units={units}
      />

      {/* Settings Popover */}
      <SettingsPopover
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        precision={precision}
        setPrecision={setPrecision}
        units={units}
        setUnit={setUnit}
        layoutMode={layoutMode}
        setLayoutMode={setLayoutMode}
      />

      {/* Confirmation Dialog for Deletions */}
      <TelemetryConfirmDialog
        state={confirmState}
        onCancel={closeConfirmDialog}
        onConfirm={handleConfirm}
      />
    </Fragment>
  );
};

export default TelemetryModals;
